/*
 * @Author: e4glet
 * @Date: 2020-07-09 00:46:22
 * @LastEditTime: 2020-07-09 22:23:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue-cli4-framwork\src\router\index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
/**
 * 引入后台模版(常用的可以预加载，不常用的可以使用懒加载)
 */
import TopNav from '@/components/nav/topNav.vue'
import LeftNav from '@/components/nav/leftNav.vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({
  easing: 'ease', // 动画方式
  speed: 500, // 递增进度条的速度
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3 // 初始化时的最小百分比
})



Vue.use(VueRouter)

//通过name和type动态加载菜单
//组件加载方式使用懒加载
const routes = [{
  path: '/',
  type: 'home',
  name: 'home',
  redirect: '/search',
  component: () => import( /* webpackChunkName: "home" */ '@/views/Home.vue'),
  children: [{
    path: '/search',
    name: '标准检索',
    props: true,
    meta: {
      title: '标准检索',
      role: ['admin', 'editor', 'user']
    }, //活动子页面打标签，这样tags可以显示
    components: {
      default: () => import( /* webpackChunkName: "topNav" */ '@/views/workbench/dashboard.vue'),
      top: TopNav,
      aside: LeftNav,

    },
    leaf: true, // 只有一个节点
    iconCls: 'iconfont icon-home', // 图标样式class
    menuShow: true,
	imgs:require('../assets/images/left_ong.png')
  },
  {
  	    path: '/upload',
  		name: '标准录入',
  		meta: {
  		  title: '标准录入',
  		  role: ['admin', 'editor', 'user']
  		}, //活动
  	    components: {
  	      default: () => import( /* webpackChunkName: "mySet" */ '@/views/docsmanager/upload.vue'),
  	      top: TopNav,
  	      aside: LeftNav
  	    },
  	    iconCls: 'el-icon-menu',
  	    menuShow: true,
  		leaf: true, // 只有一个节点
  		imgs:require('../assets/images/record.png')
  },
      {
      	    path: '/enterprise',
      		name: '企业列表',
      		meta: {
      		  title: '企业列表',
      		  role: ['admin', 'editor', 'user']
      		}, //活动
      	    components: {
      	      default: () => import( /* webpackChunkName: "mySet" */ '@/views/workbench/comlist.vue'),
      	      top: TopNav,
      	      aside: LeftNav
      	    },
      	    iconCls: 'el-icon-menu',
      	    menuShow: true,
      		leaf: true, // 只有一个节点
      		imgs:require('../assets/images/qiye.png')
      },
      // {
      //     path: '/statistics',
      //     name: '数据统计',
      //     meta: {
      //         title: '数据统计',
      //         role: ['admin', 'editor', 'user']
      //     }, //活动
      //     components: {
      //         default: () => import( /* webpackChunkName: "mySet" */ '@/views/workbench/statistics.vue'),
      //         top: TopNav,
      //         aside: LeftNav
      //     },
      //     iconCls: 'el-icon-menu',
      //     menuShow: true,
      //     leaf: true, // 只有一个节点
      //     imgs:require('../assets/images/statistics.png')
      // },
  {
  	    path: '/map',
  		name: '标准地图',
  		meta: {
  		  title: '标准地图',
  		  role: ['admin', 'editor', 'user']
  		}, //活动
  	    components: {
  	      default: () => import( /* webpackChunkName: "mySet" */ '@/views/docsmanager/map.vue'),
  	      top: TopNav,
  	      aside: LeftNav
  	    },
  	    iconCls: 'el-icon-menu',
  	    menuShow: true,
  		leaf: true, // 只有一个节点
		imgs:require('../assets/images/left_map.png')
  },
  {
  	    path: '/s_management',
		name: '标准管理',
		meta: {
		  title: '标准管理',
		  role: ['admin', 'editor', 'user']
		}, //活动
  	    components: {
  	      default: () => import( /* webpackChunkName: "mySet" */ '@/views/Smanagement.vue'),
  	      top: TopNav,
  	      aside: LeftNav
  	    },
  	    iconCls: 'el-icon-menu',
  	    menuShow: false,
  		leaf: true, // 只有一个节点

  },
  {
    path: '/mySet',
    components: {
      default: () => import( /* webpackChunkName: "mySet" */ '@/views/workbench/mySettings.vue'),
      top: TopNav,
      aside: LeftNav
    },
    name: '业务系统',
    iconCls: 'el-icon-menu',
	imgs:require('../assets/images/left_jk.png'),
    menuShow: false,
    children: [	{
	  path: '/details',
	  component: () => import( /* webpackChunkName: "message" */ '@/views/workbench/detail.vue'),
	  name: '标准详情',
	  meta: {
	    title: '标准详情',
	    role: ['admin', 'editor', 'user']
	  },
	  menuShow: false //不显示在菜单栏中
	},{
	  path: '/com_details',
	  component: () => import( /* webpackChunkName: "message" */ '@/views/workbench/com_detail.vue'),
	  name: '公司详情',
	  meta: {
	    title: '公司详情',
	    role: ['admin', 'editor', 'user']
	  },
	  menuShow: false //不显示在菜单栏中
	},{
      path: '/mySet/addform',
      component: () => import( /* webpackChunkName: "search" */ '@/views/workbench/mywork/addform.vue'),
      name: '接口参数',
      meta: {
        title: '接口参数',
        role: ['admin', 'editor', 'user']
      },
      menuShow: true
    },
    {
      path: '/mySet/management',
      component: () => import( /* webpackChunkName: "mymanage" */ '@/views/workbench/mywork/mission.vue'),
      name: '接口测试',
      meta: {
        title: '接口测试',
        role: ['admin', 'editor', 'user']
      },
      menuShow: true
    },
    {
      path: '/message',
      component: () => import( /* webpackChunkName: "message" */ '@/views/workbench/user/message.vue'),
      name: '系统消息',
      meta: {
        title: '系统消息',
        role: ['admin', 'editor', 'user']
      },
      menuShow: false //不显示在菜单栏中
    },
    {
      path: '/user/changepwd',
      component: () => import( /* webpackChunkName: "changepwd" */ '@/views/workbench/user/changePassword.vue'),
      name: '修改密码',
      meta: {
        title: '修改密码',
        role: ['admin', 'editor', 'user']
      },
      menuShow: false //不显示在菜单栏中
    },
    {
      path: '/403',
      meta: {
        title: '无访问权限',
        role: ['admin', 'editor', 'user']
      },
      component: () => import( /* webpackChunkName: "Login" */ '@/components/403.vue'),
      menuShow: false //不显示在菜单栏中
    },
    ]
  }
  ]
},
{
  path: '/docsmanager',
  type: 'docs',
  name: 'docs',
  component: () => import( /* webpackChunkName: "home" */ '@/views/Home.vue'),
  redirect: '/docsmanager/list',
  menuShow: true,
  children: [{
    path: '/docsmanager/list',
    name: '文件管理',
    meta: {
      title: '文件管理',
      role: ['admin', 'editor', 'user']
    },
    components: {
      default: () => import( /* webpackChunkName: "docsList" */ '@/views/docsmanager/index.vue'),
      top: TopNav,
      aside: LeftNav
    },
    leaf: true,
    iconCls: 'el-icon-setting',
    menuShow: true
  },
  {
    path: '/docsmanager/detail',
    name: '文件详细',
    meta: {
      title: '文件详细',
      role: ['admin', 'editor', 'user']
    },
    components: {
      default: () => import( /* webpackChunkName: "docsDetail" */ '@/views/docsmanager/detail.vue'),
      top: TopNav,
      aside: LeftNav
    },
    leaf: true,
    iconCls: 'el-icon-setting',
    menuShow: false
  },
  {
    path: '/docsmanager/add',
    name: '新建文件',
    meta: {
      title: '新建文件',
      role: ['admin', 'editor', 'user']
    },
    components: {
      default: () => import( /* webpackChunkName: "docsAdd" */ '@/views/docsmanager/add.vue'),
      top: TopNav,
      aside: LeftNav
    },
    leaf: true,
    iconCls: 'el-icon-edit',
    menuShow: true
  },
  {
    path: '/docsmanager/upload',
    name: 'ICD文档导入',
    meta: {
      title: '文档导入',
      role: ['admin', 'editor']
    },
    components: {
      default: () => import( /* webpackChunkName: "docsUpload" */ '@/views/docsmanager/docsupload.vue'),
      top: TopNav,
      aside: LeftNav
    },
    leaf: true,
    iconCls: 'el-icon-upload',
    menuShow: true
  }
  ]
},
{ //系统登录首页
  path: '/login',
  name: 'login',
  type: 'login',
  component: () => import( /* webpackChunkName: "Login" */ '@/views/Login.vue')
},
    { //系统登录首页
        path: '/upload-mobile',
        name: 'upload-mobile',
        type: 'upload-mobile',
        meta: {
            name:"viewport",
            content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
        component: () => import( /* webpackChunkName: "Login" */ '@/views/docsmanager/upload.vue')
    },

    // { //系统登录首页
    //     path: '/404',
    //     name: '404',
    //     type: '404',
    //     component: () => import( /* webpackChunkName: "Login" */ '@/views/404.vue')
    // },

{
  path: '*',
  meta: {
    title: '404',
    role: ['admin', 'editor', 'user']
  },
  component: () => import( /* webpackChunkName: "404" */ '@/components/404.vue')
}
]

const router = new VueRouter({
  //mode: 'hash',  //hash  or history
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  NProgress.start();
  next()
  // console.log('to:' + to.path)
 //  if (to.path.startsWith('/login')) {
 //    window.localStorage.removeItem('Authorization')
 //    next()
 //  } else {
 //    let user = JSON.parse(window.localStorage.getItem('Authorization'))


 //    if (!user) {
 //      next({
 //        path: '/login'
 //      })
 //      NProgress.done()
 //    } else if (to.meta.role.indexOf(user.rolename) >= 0) {
 //      next()
 //    } else {
 //      next({
 //        path: '/403'
 //      })
 //    }
 //  }
});

router.afterEach(() => {
  // 在即将进入新的页面组件前，关闭掉进度条
  NProgress.done()
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
